import config from '@/config'
import { ITrackCommunitiesAccessEvent, ITrackEvent } from '@/models/TrackEvent'
import { useGlobalStore } from '@/store/app'
import { isMobile } from '@/util/helper'
import { AnalyticsService as ClientPortalAnalyticsService } from '@ghl/clientportal-core'
import { requests } from './HTTPService'
import { ServiceWithStoreDependencies } from './decorators/serviceDecorators'

export enum CommunitiesPendoEventType {
  COMMUNITY_USER_ENGAGEMENT = 'community-user-engagement',
}

const http = requests(config.COMMUNITIES_SERVER_URL)

@ServiceWithStoreDependencies('groupId')
class AnalyticsServiceCls {
  protected basePath = '/health'

  constructor() {}

  async trackEvent(trackEvent: ITrackEvent): Promise<void> {
    const appStore = useGlobalStore()

    const enrichedTrackEvent = {
      ...trackEvent,
      locationId: appStore.locationId,
      groupId: appStore.groupId,
    }

    await http.post(`${this.basePath}/track-event`, enrichedTrackEvent)
  }

  async trackCommunitiesAccessEvent(
    trackEvent: ITrackCommunitiesAccessEvent
  ): Promise<void> {
    await http.post(
      `${this.basePath}/track-communities-access-event`,
      trackEvent
    )
  }

  async trackPendoEvent(payload: {
    eventType: CommunitiesPendoEventType
    locationId: string
    properties: Record<string, any>
  }): Promise<void> {
    try {
      const enrichedProperties = {
        ...payload.properties,
        userAgent: isMobile() ? 'mobile' : 'desktop',
      }
      payload.properties = enrichedProperties
      await ClientPortalAnalyticsService.trackPendoEvents(payload)
    } catch (error) {
      console.error('Failed to send Pendo tracking event:', error)
    }
  }
}

// Export singleton instance
export const AnalyticsService = new AnalyticsServiceCls()

// Export type for dependency injection
export type IAnalyticsService = AnalyticsServiceCls

// Export commonly used methods directly
export const { trackEvent, trackPendoEvent } = AnalyticsService
